import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ITagsParams } from '../types/actionParams';

export class AddTagsToPublishedConnectionTablesRequest extends Request<ITagsParams, IResult> {
  constructor(ids: string[], tags: string[]) {
    super('addTagsToPublishedConnectionTables', {
      ids: ids,
      tags: tags
    });
  }
}
